import graphApiSlice from 'src/shared/state/api-slices/graphApiSlice';
import { ProjectSamplingCadenceType, SamplingEvent, ProgressStatus, CMSHabitatAssayType, SubscriptionType } from 'src/shared/types';

import {
    CreateProjectDefinitionQueryResult,
    createProjectDefinitonQuery,
    ProjectDefinitionCompletionQueryResult,
    projectDefinitionCompletionQuery,
    getSubscriptionTypesQuery,
    GetSubscriptionTypeResult,
} from './queries/newProjectDefinitionQuery';

type HasProjectDefinitionQueryParams = {
    projectId: string;
};

type CreateProjectDefinitionParams = {
    customerId: string;
    projectName: string;
    projectId: string;
    projectCode: string;
    country: string;
    samplingCadenceType: ProjectSamplingCadenceType;
    samplingEvent: Pick<SamplingEvent, 'name' | 'fromDate' | 'toDate'>[];
    projectLifespanYears: number;
    habitatAssay: Pick<CMSHabitatAssayType, 'assayName' | 'habitatAssayKey' | 'habitatName'>[];
    projectLeadName: string;
    projectLeadEmail: string;
    projectLeadRole: string;
    sampleGroups: string[];
    status: ProgressStatus;
    hasDefinedSampleEvents: boolean;
    subscriptionType?: SubscriptionType;
};

const newProjectDefinitionGraphSlice = graphApiSlice.injectEndpoints({
    endpoints: builder => ({
        hasProjectDefinition: builder.query<ProjectDefinitionCompletionQueryResult, HasProjectDefinitionQueryParams>({
            query: params => ({
                body: projectDefinitionCompletionQuery,
                variables: params,
            }),
        }),
        getSubscriptionTypes: builder.query<GetSubscriptionTypeResult, null>({
            query: () => ({
                body: getSubscriptionTypesQuery,
            }),
        }),
        createProjectDefiniton: builder.mutation<CreateProjectDefinitionQueryResult, CreateProjectDefinitionParams>({
            query: params => ({
                body: createProjectDefinitonQuery,
                variables: { input: params },
            }),
            // Saving a definition changes what the admin projects list reports about a
            // project, so the cached definition list must expire — otherwise returning to
            // the organisation page still shows the project as having no definition.
            invalidatesTags: ['project'],
        }),
    }),
});

export const {
    useCreateProjectDefinitonMutation,
    useHasProjectDefinitionQuery,
    useGetSubscriptionTypesQuery,
    useLazyHasProjectDefinitionQuery,
} = newProjectDefinitionGraphSlice;
